import React from 'react';
import { connect } from 'react-redux';
import { closeSnack} from "../actions/snackBar.action.js";
import { LinearProgress, Snackbar } from "@material-ui/core";
import { Alert } from '@material-ui/lab';

const SnackBarMui = (rest) => {
  return (
    <Snackbar
      anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      open={rest.snackOpened}
      onClose={rest.closeSnack}
      autoHideDuration={rest.hideDuration?rest.hideDuration:null}
    >
      <div>
        <Alert severity={rest.alertType}>
          {rest.alertMessage}
        </Alert>
        {rest.snackLoading ? <LinearProgress /> : null}
      </div>
    </Snackbar>
  );
};

const mapStateToProps = (state) => ({
  snackOpened:state.snackBarReducer.snackOpened,
  alertType:state.snackBarReducer.alertType,
  alertMessage:state.snackBarReducer.alertMessage,
  snackLoading:state.snackBarReducer.snackLoading,
  hideDuration:state.snackBarReducer.hideDuration
});

const mapDispatchToProps = (dispatch) => {
  return {
    closeSnack:() => dispatch(closeSnack())
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(SnackBarMui);
